import * as React from "react";
const SvgBlank = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "" }));
export default SvgBlank;
